/**
 * User: danielgw
 * Date: 2/17/17
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');

    var FilterMcsViewController = BaseFilterViewController.extend({
        ControllerName: 'FilterMcsViewController',
        LPViewMap: {
            button: ".lpview_button",
            buttonClass: ".lpview_button_",
            fromInput: ".lpview_fromInput",
            toInput: ".lpview_toInput"
        },
        LPClassesMap: {
            checked: "checked",
            button: "lpview_button_"
        },
        Range: {
            min: -100,
            max: 100
        },
        initialize: function (constructorData) {
            this.selectedTag = {};
            this.filterName = constructorData.filterName;
            this.filterTextSuffix = constructorData.filterTextSuffix;
            this.filterPrefix = "status";
            var DEFAULT_FILTER_OPTIONS = {
                fromMcs: this.Range.min,
                toMcs: this.Range.max,
                status: "0"
            };
            this.defaultFilter = constructorData.defaultFilter || DEFAULT_FILTER_OPTIONS;

            // preset filters
            this.filterResetData = lpUtils.cloneObject(this.defaultFilter);
            this.filterUIData = lpUtils.cloneObject(this.defaultFilter);
            this.filterData = lpUtils.cloneObject(this.defaultFilter);

            this.initializeView();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.button, DOMEvent: "click", callback: this.buttonClicked});
        },

        render: function () {
            this.onShow();
        }
    });

    FilterMcsViewController.prototype.initializeView = function () {
        var radiosHTML = "";
        var textInjection;
        var iconTemplate = require("web-agent-templates/LP_filter_single_icon_text.html");
        var rangeTemplate = require("web-agent-templates/LP_filter_single_range.html");
        // var iconTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_icon_text.html");
        // var rangeTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_range.html");
        var positiveInjection = {
            sentiment: "positive",
            text: agentLEManager.translateLE("LEWebAgent.filter_mcs_positive")
        };
        var negativeInjection = {
            sentiment: "negative",
            text: agentLEManager.translateLE("LEWebAgent.filter_mcs_negative")
        };
        var rangeInjection = {
            from: agentLEManager.translateLE("LEWebAgent.filter_mcs_from"),
            to: agentLEManager.translateLE("LEWebAgent.filter_mcs_to")
        };

        this.buttons = [
            {
                status: "0",
                buttonId: "all",
                content: agentLEManager.translateLE("LEWebAgent.all")
            },
            {
                status: "1",
                buttonId: "positive",
                content: this.injectTextDefaults(iconTemplate, positiveInjection)
            },
            {
                status: "-1",
                buttonId: "negative",
                content: this.injectTextDefaults(iconTemplate, negativeInjection)
            },
            {
                status: "2",
                buttonId: "range",
                content: this.injectTextDefaults(rangeTemplate, rangeInjection)
            }
        ];

        var radioTemplate = require("web-agent-templates/LP_filter_single_radio_select_view.html");
        // var radioTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_radio_select_view.html");
        for (var i = 0, l = this.buttons.length; i < l; i++) {
            textInjection = this.buttons[i];
            radiosHTML += this.injectTextDefaults(radioTemplate, textInjection);
        }

        var filterTemplate = require("web-agent-templates/LP_MCS_filter_view.html");
        // var filterTemplate = lpUtils.loadResource("web-agent-templates/LP_MCS_filter_view.html");
        textInjection = {
            radio_buttons: radiosHTML
        };
        filterTemplate = this.injectTextDefaults(filterTemplate, textInjection);
        this.createView({template: filterTemplate, target: this.LPViewMap.filterArea });

        this.fromVC = new NumericInputViewController({
            defaultInputValue: this.filterUIData.fromMcs,
            minimumInputValue: this.Range.min,
            maximumInputValue: this.Range.max,
            valueChangedCallback: this.fromUpdated,
            lostFocusCallback: this.setFocus,
            context: this
        });
        this.addViewController({viewController: this.fromVC, target: this.LPViewMap.fromInput});

        this.toVC = new NumericInputViewController({
            defaultInputValue: this.filterUIData.toMcs,
            minimumInputValue: this.Range.min,
            maximumInputValue: this.Range.max,
            valueChangedCallback: this.toUpdated,
            lostFocusCallback: this.setFocus,
            context: this
        });
        this.addViewController({viewController: this.toVC, target: this.LPViewMap.toInput});
    };

// When a radio clicked, identify the button and active the button logic on it.
    FilterMcsViewController.prototype.buttonClicked = function (data) {
        var clickedElement = data.currentTarget;

        // set filter UI data according to the selection
        for (var i = 0, l = this.buttons.length; i < l; i++) {
            if (this.hasClass(clickedElement, this.LPClassesMap.button + this.buttons[i].buttonId)[0] === true) {
                this.filterUIData[this.filterPrefix] = this.buttons[i].status;
            }
        }

        // update UI
        this.updateFilterUI();
    };

    FilterMcsViewController.prototype.onShow = function () {
        this.updateFilterUI();
        // preset buttons
        BaseFilterViewController.prototype.onShow.call(this);
    };


// set the buttons and input according to the data in the filter
    FilterMcsViewController.prototype.updateFilterUI = function () {
        this.removeClassMultiElements(this.LPViewMap.button, this.LPClassesMap.checked);
        this.fromVC.setMaximumInputValue(this.Range.max);
        this.toVC.setMinimumInputValue(this.Range.min);
        for (var i = 0, l = this.buttons.length; i < l; i++) {
            if (this.filterUIData[this.filterPrefix] === this.buttons[i].status) {
                this.addClass(this.LPViewMap.buttonClass + this.buttons[i].buttonId, this.LPClassesMap.checked);
                break;
            }
        }

        this.fromVC.setCurrentInputValue(this.filterUIData.fromMcs);
        this.toVC.setCurrentInputValue(this.filterUIData.toMcs);
    };

    FilterMcsViewController.prototype.fromUpdated = function (value) {
        this.filterUIData.fromMcs = value;
        // The From set the minimum of the To value. if it is bigger then the max then set it to the max.
        this.toVC.setMinimumInputValue(this.filterUIData.fromMcs + 1 <= this.Range.max ? this.filterUIData.fromMcs + 1 : this.Range.max);
        this.updateFilterUI();
    };

    FilterMcsViewController.prototype.toUpdated = function (value) {
        this.filterUIData.toMcs = value;
        // The To value set the maximum of the From value. if it is smaller than the min then set it to the min.
        this.fromVC.setMaximumInputValue(this.filterUIData.toMcs - 1 >= this.Range.min ? this.filterUIData.toMcs - 1 : this.Range.min);
        this.updateFilterUI();
    };

    return FilterMcsViewController;

});
